import React, {useState/*, useContext */ } from 'react';
import { Button, Modal, Form, Input } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

function SubscribeStage(props) {
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);
    // console.warn('stato di props.registrationInfo: ', props.registrationInfo);

    function toggleModal() {
        // console.warn('arrivato a toggle!!');
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
        setIsActive(false);
        form.resetFields();
    }

    function onUnsubscribe() {
        console.warn('deregistrazione da fare');
    }
    
    async function onFinish(values) {
        values.stageId = props.stageId
        // console.warn('values della form: ', values)
        
        props.onSubscribe.mutate(values)
        setIsActive(false);
    }

    // console.warn(props.registrationInfo);
    if (props.registrationInfo.registered === true && props.registrationInfo.info.length > 0) {
        return (
            <div>
                <Modal title="Aggiorna dati" open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} cancelText="Annulla" okText="Aggiorna">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }} initialValues={{"id": props.registrationInfo.info[0].deckId, "deckName": props.registrationInfo.info[0].deckName, "TxtDeckList": props.registrationInfo.info[0].txtDeckList, "deckLink": props.registrationInfo.info[0].deckLink }}>
                        <Form.Item label="Nome Mazzo" name="deckName" rules={[{ required: true, message: 'Please insert your deck \'s name!' }]}>
                            <Input placeholder="Nome" />
                        </Form.Item>
                        <Form.Item label="Decklist" name="TxtDeckList" tooltip={{ title: 'Inserire la lista in formato txt, nel seguente modo: <nr copie> <nome carta in inglese>', icon: <InfoCircleOutlined /> }}>
                            <Input placeholder="Decklist" />
                        </Form.Item>
                        <Form.Item label="Link" name="deckLink" tooltip={{ title: 'Se si dispone di un link verso mtggoldfish o moxfield, inserirlo qui.', icon:  <InfoCircleOutlined /> }}>
                            <Input placeholder="Link Decklist" />
                        </Form.Item>
                        <Form.Item hidden name="id" />
                    </Form>
                </Modal>
                <Button style={{ marginTop: 16, marginRight: 16 }} type="primary" onClick={toggleModal}>
                    Aggiorna Iscrizione
                </Button>
                <Button danger type="primary" onClick={onUnsubscribe}>Annulla Iscrizione</Button>
            </div>
        );
    }
    return(
            <div>
                <Modal title="Iscriviti alla tappa" open={isActive} trigger="click" onOk={form.submit} onCancel={handleCancel} cancelText="Annulla" okText="Iscriviti">
                    <Form form={form} onFinish={onFinish} labelCol={{ span: 8, }} wrapperCol={{ span: 16, }}>
                        <Form.Item label="Nome Mazzo" name="deckName" rules={[{ required: true, message: 'Please insert your deck \'s name!' }]}>
                            <Input placeholder="Nome" />
                        </Form.Item>
                        <Form.Item label="Decklist" name="TxtDeckList" tooltip={{ title: 'Inserire la lista in formato txt,  nel seguente modo: <nr copie> <nome carta in inglese> ', icon: <InfoCircleOutlined /> }}>
                            <Input.TextArea rows={20} placeholder="Decklist" />
                        </Form.Item>
                        <Form.Item label="Link" name="deckLink" tooltip={{ title: 'Se si dispone di un link verso mtggoldfish o moxfield, inserirlo qui.', icon:  <InfoCircleOutlined /> }}>
                            <Input placeholder="Link Decklist" />
                        </Form.Item>
                    </Form>
                </Modal>
                <Button style={{ marginTop: 16 }} type="primary" onClick={toggleModal}>
                    Iscriviti
                </Button>
            </div>
    )
}

export default SubscribeStage;